import { Component, Input } from '@angular/core';
import { IStat } from '../../interfaces/stat.interface';

/**
 * @deprecated `@suvo/frontend-framework/standalone/components/visualisations/stat.component` can be
 *   used.
 */
@Component({
  standalone: false,
  selector: 'lib-basic-stat',
  templateUrl: './basic-stat.component.html',
  styleUrls: ['./basic-stat.component.scss'],
})
export class BasicStatComponent {
  @Input() stat: IStat;
}
